import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Thermometer, Activity, Coffee, Moon } from 'lucide-react';

export default function BodyType() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-soft-ivory" data-testid="body-type-page">
      <section className="section-padding">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12 space-y-6"
          >
            <p className="overline text-tiger-orange">TIGER CIRCLE</p>
            <h1 className="heading-1">Know Your Body Type</h1>
            <p className="body-text text-dark-cedar/80 max-w-2xl mx-auto">
              Understanding your unique body constitution helps us curate the perfect wellness rituals for you. Our approach is inspired by East-Asian medicine principles, focusing on your natural tendencies and patterns.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-desert-sand/30 rounded-2xl p-12 space-y-8"
          >
            <h2 className="heading-3 text-center">Body Type Assessment</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="card-flat p-6 space-y-4">
                <Thermometer className="w-10 h-10 text-tiger-orange" />
                <h3 className="font-playfair text-xl font-semibold">Temperature Tendency</h3>
                <p className="text-sm text-dark-cedar/70">
                  Do you tend to feel cold or hot? This reveals important information about your circulation and metabolic patterns.
                </p>
              </div>

              <div className="card-flat p-6 space-y-4">
                <Activity className="w-10 h-10 text-tiger-orange" />
                <h3 className="font-playfair text-xl font-semibold">Digestion Pattern</h3>
                <p className="text-sm text-dark-cedar/70">
                  Your digestive tendencies—whether you experience bloating, irregular patterns, or specific sensitivities—guide our recommendations.
                </p>
              </div>

              <div className="card-flat p-6 space-y-4">
                <Coffee className="w-10 h-10 text-tiger-orange" />
                <h3 className="font-playfair text-xl font-semibold">Energy Rhythms</h3>
                <p className="text-sm text-dark-cedar/70">
                  When do you feel most energized? Understanding your natural energy cycles helps optimize ritual timing.
                </p>
              </div>

              <div className="card-flat p-6 space-y-4">
                <Moon className="w-10 h-10 text-tiger-orange" />
                <h3 className="font-playfair text-xl font-semibold">Sleep Quality</h3>
                <p className="text-sm text-dark-cedar/70">
                  Your sleep patterns reveal insights about nervous system balance and recovery capacity.
                </p>
              </div>
            </div>

            <div className="text-center pt-8 space-y-4">
              <div className="bg-tiger-orange/10 border-l-4 border-tiger-orange rounded-r-lg p-6">
                <p className="font-inter text-lg font-semibold text-dark-cedar mb-2">
                  Coming Soon
                </p>
                <p className="text-sm text-dark-cedar/70">
                  We're perfecting our comprehensive body type assessment quiz. It will provide personalized insights and ritual recommendations based on your unique constitution.
                </p>
              </div>
              
              <Button onClick={() => navigate('/tiger-circle/tea')} className="btn-primary">
                Try Our Tea Ritual Quiz Instead
              </Button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}